import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCargos(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].GET_CARGOS,
		options
	)
}

function _getCargo(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO,
		options
	)
}

function _createCargo(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].CREATE_CARGO,
		options
	)
}

function _putCargo(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].PUT_CARGO,
		options
	)
}

function _patchCargo(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].PATCH_CARGO,
		options
	)
}

function _deleteCargo(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].DELETE_CARGO,
		options
	)
}

function _getCargoPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_PREVIEW,
		options
	)
}

function _getCargoPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGOS,
		ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGOS]: _getCargos,

	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO]: _getCargo,
	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_PREVIEW]: _getCargoPreview,
	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_POPUP]: _getCargoPopup,

	[ModulesConfigMap[ModulesMap.CARGOS].CREATE_CARGO]: _createCargo,
	[ModulesConfigMap[ModulesMap.CARGOS].PUT_CARGO]: _putCargo,
	[ModulesConfigMap[ModulesMap.CARGOS].PATCH_CARGO]: _patchCargo,
	[ModulesConfigMap[ModulesMap.CARGOS].DELETE_CARGO]: _deleteCargo,
}